// Owner: dashboards-core (plan §9.16); the screen lives in `-DashboardRoute.tsx` and loads with the route,
// not with the app's first paint (plan §10.2).
import { createFileRoute } from '@tanstack/react-router';
import { dashboardAddress } from '../../../features/dashboards/address';
import { DashboardRoute } from './-DashboardRoute';

export const Route = createFileRoute('/_app/dashboards/$dashboardId')({
  validateSearch: dashboardAddress,
  component: DashboardRoute,
});
